import { z } from 'zod';

/**
 * Validation schemas for the contract article suggestions API call.
 */

// Query parameter validations
export const zodContractArticleSuggestionsQueryParamsSchema = z.object({
  buyerCompanyId: z.uuid().optional(),
  excludeContractId: z.uuid().optional(),
  limit: z.number().int().min(1).max(50).optional().prefault(50),
  query: z.string().trim().optional(),
  sellerCompanyId: z.uuid().optional(),
});

// Response schema
export const zodContractArticleSuggestionItemSchema = z.object({
  buyerArticleId: z.string().trim().nullish(),
  contractItemId: z.uuid(),
  manufacturer: z.string().trim().nullish(),
  productDescription: z.string().trim().nullish(),
  productName: z.string().trim(),
  sellerArticleId: z.string().trim().nullish(),
  unitType: z.string().trim(),
  usageCount: z.number().int().nonnegative(),
});

export const zodContractArticleSuggestionsResponseSchema = z.object({
  data: z.array(zodContractArticleSuggestionItemSchema),
});
